const AbiBillingApiUrls = {
  GET: `${process.env.REACT_APP_USER_ABI_URL}/abi/billing/get`,
};

export default AbiBillingApiUrls;
